import { FC } from 'react';

import ServicesBlockItem from './ServicesBlockItem/ServicesBlockItem';

import { ServicesBlockType } from '@/types';

interface IServicesBlockProps {
  webdesignBlock: ServicesBlockType[];
}

const ServicesBlock: FC<IServicesBlockProps> = ({ webdesignBlock }) => {
  return (
    <>
      <ul className={'card-set [--card-gap:30px]'}>
        {webdesignBlock.map(({ id, title, text }: ServicesBlockType) => (
          <li
            key={id}
            className={
              'card-set-item md:[--card-item:2] lg:[--card-item:3]  w-full  '
            }
          >
            <ServicesBlockItem title={title} text={text} />
          </li>
        ))}
      </ul>
    </>
  );
};

export default ServicesBlock;
